<ng-content></ng-content>
<section class="confetti-container">
  <ng-lottie class="mdk-lottie" [options]="lottieConfig" />
</section>
